import * as React from 'react';
import { TemplateData } from '../App';
import { deviceDetect, BrowserView, isMobile } from 'react-device-detect';

import { TemplatePreviewLiteProps, convertToStepTimes, TemplatePreviewLite } from '@prezi/template-preview-lite';
import * as styles from '../css/TemplateHeader.less';
import { DescriptionBottom, EdgeMask, PreziBG, TemplateDetail, TemplateHero, TemplateHeroOffset,
    TemplatePreviewVideoOnlyImg, TemplatePreviewVideoOnlyVideo } from '../styles/TemplateHeader';
import { glassboxWebJs } from '@prezi/client-logger-module';

const device = deviceDetect();
const isEdge = device.browserName === 'Edge';
const isIE = device.browserName === 'IE';

export interface TemplateHeaderProps {
    template: TemplateData;
    isAuthenticated: boolean;
    preloadPreviewVideos: boolean;
    useThisTemplateCTA: string;
    getStartedCTA: string;
    usePARF: boolean;
}

export class TemplateHeader extends React.Component<TemplateHeaderProps, any> {
    constructor(props: TemplateHeaderProps) {
        super(props);
    }

    getTemplateURL(): string {
        const props = [
            'click_source=logged_element',
            'page_location=template_hero_cta',
            'element_text=use_this_template',
        ].join('&');

        if (this.props.isAuthenticated) {
            return '/p/create-prezi/?' + props + '&from-template-key=' + encodeURIComponent(this.props.template.template_key);
        } else {
            return '/signup/basic/?' + props + '&next=/p/create-prezi/?from-template-key=' + encodeURIComponent(this.props.template.template_key);
        }
    }

    getCTAElement(): React.ReactChild {
        if (this.props.usePARF && !this.props.isAuthenticated) {
            const landingURL = `/p/create-prezi/?from-template-key=${encodeURIComponent(this.props.template.template_key)}`;
            const logClick = (e: React.MouseEvent<HTMLElement>) => {
                glassboxWebJs.logUseWebTemplate({ template_slug: this.props.template.slug });
            };
            return <a href={ `javascript:AltRegFlow.openPARF('${landingURL}')` }
                      onClick={ logClick } className={ 'btn-md green btn-responsive hidden-xs' }>{ this.props.useThisTemplateCTA }</a>;
        }
        return <a href={ this.getTemplateURL() } className={ 'btn-md green btn-responsive hidden-xs' }>{ this.props.useThisTemplateCTA }</a>;
    }

    render() {
        const cmsClasses = this.props.template.element_id ? ` cms-prezi-plugin-edit cms-plugin cms-plugin-${this.props.template.element_id}` : '';
        const showPreview = !(isIE || isEdge || isMobile);

        const preziBG: React.CSSProperties = {
            zIndex: -2,
            background: `linear-gradient(45deg, rgba(21, 34, 53, .7), rgba(21, 34, 53, .7) 100%), url('${this.props.template.thumbnail_url}')`,
        };

        let templatePreviewContainer = styles.templatePreviewContainer;

        if (!showPreview) {
            // Eliminate the space used by the forward/back buttons
            templatePreviewContainer = styles.templatePreviewContainerVideoOnly;
        }

        const props: TemplatePreviewLiteProps = {
            stepTimes: this.props.template.video_metadata ? convertToStepTimes(this.props.template.video_metadata) : [],
            templatePreviewUrl: this.props.template.video_url ? this.props.template.video_url : '',
            templateThumbnailUrl: this.props.template.thumbnail_url,
            preloadPreviewVideo: this.props.preloadPreviewVideos,
            templatePreviewDimensions: {
                height: 'auto',
                width: '100%',
            },
        };

        return (
            <section>
                <div className={ 'container' }>
                    <div className={ 'row' }>
                        <TemplateHeroOffset className={ 'col-xs-12 ' + cmsClasses }>
                            <TemplateHero>
                                <div key={ this.props.template.slug }>
                                    <div className={ 'col-xs-12 col-lg-8 pad-zero ' + templatePreviewContainer }>

                                        <BrowserView device={ !showPreview }>
                                            { (props.templatePreviewUrl) ?
                                                (<TemplatePreviewVideoOnlyVideo loop={ true } autoPlay={ true }
                                                        playsInline={ true }
                                                        muted={ true }
                                                        width="100%"
                                                        height="auto"
                                                        poster={ this.props.template.thumbnail_url }>
                                                    <source src={ props.templatePreviewUrl } type="video/mp4" /></TemplatePreviewVideoOnlyVideo>) :
                                                (<TemplatePreviewVideoOnlyImg width="100%"
                                                      height="100%"
                                                      src={ this.props.template.thumbnail_url } />) }
                                        </BrowserView>

                                        <BrowserView device={ showPreview  }>
                                            { (props.stepTimes && props.templatePreviewUrl) ?
                                                (<TemplatePreviewLite { ...props } />) :
                                                (<img className={ 'img-responsive' } src={ this.props.template.thumbnail_url } />) }
                                        </BrowserView>
                                    </div>
                                    <div className={ 'col-xs-12 col-lg-4 pad-zero' }>
                                        <TemplateDetail>
                                            <h1 className={ 'h3 btm-18 semibold' }>{ this.props.template.name }</h1>
                                            <DescriptionBottom>{ this.props.template.description }</DescriptionBottom>
                                            { this.getCTAElement() }
                                            <a href={ this.getTemplateURL() }
                                               className={ 'btn-md green btn-responsive visible-xs' }>{ this.props.getStartedCTA }</a>
                                        </TemplateDetail>
                                    </div>
                                </div>
                            </TemplateHero>
                        </TemplateHeroOffset>
                    </div>
                </div>
                <EdgeMask />
                <PreziBG style={ preziBG } className={ 'animated fadeIn' } />
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/TemplateHeader.tsx